import { SET_EDIT_MODE, RESET_EDIT_MODE } from './types';

// Initial state
const initialState = {
  isEditMode: false, // Initially set to false
};

// Reducer to handle edit mode state
const editReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EDIT_MODE:
      return {
        ...state,
        isEditMode: true,
      };
    case RESET_EDIT_MODE:
      return {
        ...state,
        isEditMode: false,
      };
    default:
      return state;
  }
};

export default editReducer; 